import { render, staticRenderFns } from "./SouthAmerica.vue?vue&type=template&id=ce78746c&"
import script from "./SouthAmerica.vue?vue&type=script&lang=js&"
export * from "./SouthAmerica.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports